import Type from 'types/type'
import { Column } from 'types/column' // eslint-disable-line
import { tKey, tObj } from 'helpers/methods/translate'
import store from 'redux/store'
import parseJson from 'helpers/methods/parseJson'
import time, { getLocaleFromLang } from 'helpers/methods/time'

const getStartOfDay = date => {
    const startOfDay = new Date(date)
    startOfDay.setHours(0, 0, 0, 0)
    return startOfDay
}

const isDateRangeActive = (startDate, endDate) => {
    const start = new Date(startDate)
    const end = new Date(endDate)

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()))
        return false

    const today = getStartOfDay(new Date())

    return getStartOfDay(start).getTime() <= today.getTime()
        && getStartOfDay(end).getTime() >= today.getTime()
}

const renderDateByCurrentLang = date => {
    const lang = store.getState().common?.lang
    const locale = getLocaleFromLang(lang)

    return date
        ? time(date, { locale }).getCleanDate({
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        })
        : ''
}

/**
 * List of Columns
 * @type {Column[]}
 * @readonly
 */
const homeActualitiyColumns = [
    {
        fieldName: 'title',
        name: 'title',
        type: Type.STRING,
    },
    {
        fieldName: 'homeActualityStatus.name',
        name: 'status',
        type: Type.STRING,
        onRender: item => tObj.call({ props: { lang: store.getState().common?.lang } }, parseJson(item['homeActualityStatus.name'])),
    },
    {
        fieldName: 'createdAt',
        name: 'createdAt',
        type: Type.DATE,
        onRender: item => renderDateByCurrentLang(item.createdAt),
    },
    {
        fieldName: 'displayStartDate',
        name: 'startDate',
        type: Type.DATE,
        onRender: item => renderDateByCurrentLang(item.displayStartDate),
    },
    {
        fieldName: 'displayEndDate',
        name: 'endDate',
        type: Type.DATE,
        onRender: item => renderDateByCurrentLang(item.displayEndDate),
    },
    {
        fieldName: 'companyNames',
        name: 'companies',
        type: Type.STRING,
    },
    {
        fieldName: 'startDate',
        name: 'inProgress',
        type: Type.STRING,
        onRender: item => (isDateRangeActive(item.startDate, item.endDate)
            ? tKey.call({ props: { lang: store.getState().common?.lang } }, 'active')
            : tKey.call({ props: { lang: store.getState().common?.lang } }, 'noActive')),
    },

]

export default homeActualitiyColumns
